import styled from 'styled-components';
import { TitleBold, BodyM } from '@Components/Typography/Typography.styled';
import { matchScreen } from '@Utils/layout/layoutSupport';

export const ShippingAddressWrapper = styled.div`
	background: white;
	width: 100%;
	${() =>
		matchScreen('xs') && {
			height: '100%',
		}}
`;

export const Header = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 16px;
`;

export const Heading = styled(BodyM)`
	${({ theme }) => ({ color: theme.colors.black87 })}
	${({ theme }) => theme.typography.paragraphMBold}
	margin-bottom: 10px;
`;

export const CardTitle = styled(TitleBold)`
	${({ theme }) => ({ color: theme.colors.black87 })}
`;

export const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	${() =>
		!matchScreen('xs') && {
			height: 'calc(100vh - 170px)',
			maxHeight: '50vh',
		}};
	${() =>
		matchScreen('xs') && {
			height: 'calc( 100vh - 310px )',
		}};
`;

export const ListContainer = styled.div`
	position: absolute;
	transition: all 0.1s ease-in-out;
	height: calc(100% - 115px);
	overflow-y: scroll;
	width: calc(100% - 34px);
	max-width: 100%;
	// Firefox
	${({ theme }) => ({
		scrollbarWidth: 'thin',
		scrollbarColor: `${theme.colors.grey300} transparent`,
	})}

	// Chrome, Opera, Etc.
	&::-webkit-scrollbar-thumb {
		border-radius: 12px;
		transition: all 0.2s ease-in-out;
		opacity: 1;
		box-shadow: inset 0 0 10px 10px rgb(0 0 0 / 12%);
		border: solid 4px transparent;
	}
`;
